import PropTypes from 'prop-types';

import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { Fragment } from 'react';

import CollapsibleText from '../CollapsibleText';

import Tag from '../Tag';

import BaseChip from '../BaseChip';

import Link from '../Link';

import styles from './PaymentTimelineCard.module.scss';

const PaymentTimelineCard = ({
  title,
  value,
  subtitle = null,
  tags = [],
  children = null,
  collapsible = false,
  isCollapsed = true,
  highlighted = false,
  onValueClick = null,
  outlined = true,
  gapSpacing = 'medium'
}) => {
  const ChildrenContainer = collapsible ? CollapsibleText : 'div';

  const childrenContainerProps = collapsible
    ? {
        showMoreText: trans('show.details'),
        showLessText: trans('hide.details'),
        showIcon: false,
        isCollapsed,
        collapseCompletely: true
      }
    : {};

  const cardClasses = classNames(styles['payment-timeline-card'], {
    [styles['payment-timeline-card--highlighted']]: highlighted,
    [styles['payment-timeline-card--outlined']]: outlined
  });

  const chipsContainerClasses = classNames(
    styles['payment-timeline-card__chips-container'],
    {
      [styles[`payment-timeline-card__chips-container--gap-${gapSpacing}`]]:
        gapSpacing
    }
  );

  const ValueContainer = onValueClick ? Link : 'div';
  const valueContainerProps = onValueClick
    ? {
        onClick: onValueClick
      }
    : {};

  return (
    <div className={cardClasses}>
      <div className={styles['payment-timeline-card__header']}>
        <div
          className={styles['payment-timeline-card__header-title-container']}
        >
          <h4 className={styles['payment-timeline-card__header-title']}>
            {title}
          </h4>
          <div>{subtitle}</div>
        </div>
        <ValueContainer
          className={styles['payment-timeline-card__header-value-container']}
          {...valueContainerProps}
        >
          {value}
        </ValueContainer>
      </div>

      {tags.length > 0 && (
        <div className={chipsContainerClasses}>
          {tags.map((tag, index) =>
            // if tag is a reder function, call it to get the element
            typeof tag === 'function' ? (
              <Fragment key={`tag-${index}`}>{tag()}</Fragment>
            ) : (
              <Tag key={tag.label} {...tag} />
            )
          )}
        </div>
      )}

      {children && (
        <ChildrenContainer {...childrenContainerProps}>
          {children}
        </ChildrenContainer>
      )}
    </div>
  );
};

PaymentTimelineCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  tags: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(BaseChip.propTypes), PropTypes.node])
  ),
  children: PropTypes.node,
  collapsible: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  highlighted: PropTypes.bool,
  onValueClick: PropTypes.func,
  outlined: PropTypes.bool,
  gapSpacing: PropTypes.oneOf(['medium', 'big'])
};

export default PaymentTimelineCard;
